class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Elements
    this.buttonMinus = this.querySelector('[data-button-minus]');
    this.buttonPlus = this.querySelector('[data-button-plus]');
    this.input = this.querySelector('[data-qty-input]');

    // Set default value if not present
    if (!this.input.value) this.input.value = 1;

    // Bind event listeners
    this.buttonPlus?.addEventListener('click', this.increase.bind(this));
    this.buttonMinus?.addEventListener('click', this.decrease.bind(this));
    this.input?.addEventListener('input', this.onQtyInputChange.bind(this));
  }

  increase() {
    const max = parseInt(this.input.getAttribute('max')) || Infinity;
    let current = parseInt(this.input.value) || 0;
    if (current < max) {
      this.input.value = current + 1;
      this.dispatchQtyChange();
    }
  }

  decrease() {
    const min = parseInt(this.input.getAttribute('min')) || 1;
    let current = parseInt(this.input.value) || 0;
    if (current > min) {
      this.input.value = current - 1;
      this.dispatchQtyChange();
    }
  }

  onQtyInputChange(e) {
    let value = parseInt(e.target.value) || 1;
    const min = parseInt(this.input.getAttribute('min')) || 1;
    const max = parseInt(this.input.getAttribute('max')) || Infinity;

    // Clamp the value
    if (value < min) value = min;
    if (value > max) value = max;

    this.input.value = value;
    this.dispatchQtyChange();
  }

  dispatchQtyChange() {
    this.dispatchEvent(new CustomEvent('quantity-change', {
      bubbles: true,
      composed: true,
      detail: {
        value: parseInt(this.input.value)
      }
    }));
  }
}

customElements.define('quantity-selector', QuantitySelector);
